
export default function DashboardPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/faaefee00270d1767dbb379dc458c23e.jpeg" 
                alt="Credit Pro Logo" 
                className="h-8 w-auto"
              />
            </div>
            <div className="flex items-center space-x-4">
              <button className="text-gray-500 hover:text-gray-700 cursor-pointer">
                <i className="ri-notification-line text-xl"></i>
              </button>
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                <span className="text-white text-sm font-medium">U</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Bem-vindo ao Credit Pro
            </h1>
            <p className="text-lg text-gray-600">
              Você fez login com sucesso!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
